(function () {
  'use strict';

  angular.module('web2print').factory('MessageProxy', MessageProxy);

  MessageProxy.inject = ['$q', '$http', 'Common', 'FileUpload', 'Upload'];

  function MessageProxy ($q, $http, Common, FileUpload, Upload) {
    return {
      /**
			 * Upload material to S3 bucket
			 * @param file {string} File to upload
			 * @param resolve {Object} Callback
			 */
      uploadMaterial: function (file, callback) {
        return $q(function (resolve, reject) {
          // Ask for upload signature
          const meta = {
            service: Common.get('serviceType')
          };
          FileUpload.uploadSingleFile(file, 'validation', 'material.pdf', meta)
            .success(function (signatureResponse) { // Retrieve upload signature
              const config = {
                url: signatureResponse.url,
                headers: {
                  'Content-Type': file.type,
                  'x-file-upload-header': 'file_upload'
                },
                method: 'PUT',
                data: file
              };

              // Do actual upload to S3 bucket
              Upload.http(config).then(function (uploadResponse) {
                resolve(signatureResponse);
              }, function (error) {
                if (error.status > 0)
                  reject('File upload error: ' + error.status + ', ' + error.data);
              }, function (event) {
                callback(Math.min(100, parseInt(100.0 * event.loaded / event.total)));
              });
            });
        });
      },
      doesPDFExist: function (options) {
        return $q(function (resolve, reject) {
          const retryCount = 0;
          function exists () {
            $http.post(web2print.env.pdfpreprocessBaseUrl + 'ispdfready', {
              'uuid': options.pdfFolder
            })
              .success(function (response) { // Exists
                // PDF is not copied yet by the preflight
                if (!JSON.parse(response.message)) {
                  if (retryCount < 60) {
                    return setTimeout(exists, 2000);
                  }
                  reject('Failed due to many tries');
                }
                resolve();
              })
              .error(function (error) {
                reject(error);
              });
          }
          exists();
        });
      },
      isPreviewReady: function (options, callback) {
        return $q(function (resolve, reject) {
          let retryCount = 0;
          let delay = 1000;
          function exists () {
            $http.post(web2print.env.pdfpreprocessBaseUrl + 'ispreviewready', {
              'uuid': options.pdfFolder
            })
              .success(function (response) { // Exists
                const message = JSON.parse(response.message);
                callback(message.finished, message.state);
                if (!message.finished) {
                  if (retryCount < 60) {
                    return setTimeout(exists, ++retryCount % 10 == 0 ? delay *= 2 : delay);
                  }
                  reject('Failed due to many tries');
                }
                resolve(message.url);
              })
              .error(function (error) {
                reject(error);
              });
          }
          exists();
        });
      },
      generatePreview: function (options, callback) {
        const isPreviewReady = this.isPreviewReady;

        return this.doesPDFExist(options)
          .then(function () {
            return $q(function (resolve, reject) {
              $http.post(web2print.env.pdfpreprocessBaseUrl + 'preview', options)
                .success(function (response) {
                  resolve(response);
                })
                .error(function (error) {
                  reject(error);
                });
            });
          })
          .then(function () {
            return isPreviewReady(options, callback);
          });
      },
      generatePreviewParams: function () {
        const csvFolder = Common.get('recipients.addressType') === 'FILE' || //For Ebrev
          Common.get('recipients.addressType') === 'ADR' && //For Rfix
          Common.get('recipients.targetType') === 'FILE' ? Common.get('recipients.csvFolder') : null;

        const options = {
          csvFolder: csvFolder,
          pdfFolder: Common.get('materialFolderId'),
          senderData: JSON.stringify(Common.get('senderInfo')),
          preface: JSON.stringify(Common.get('preface', false)),
          service: Common.get('serviceType'),
          language: pnTopbar.language,
          addressType: Common.get('recipients.addressType'),
          deliveryDate: Common.get('productDelivery').deliveryDate
        };

        return options;
      },
      validateMaterial: function (pdfFolder, pdfProportions, pdfAdditions) {
        return $q(function (resolve, reject) {
          console.log(web2print.env.pdfpreprocessBaseUrl);
          $http({
            method: 'POST',
            url: web2print.env.pdfpreprocessBaseUrl + 'validate',
            data: {
              'pdfFolder': pdfFolder,
              'pdfProportions': pdfProportions,
              'pdfAdditions': pdfAdditions
            }
          }).then(function (response) {
            resolve(JSON.parse(response.data.message));
          }, function (response) {
            reject('Pdf validation crashed');
          });
        });
      },
      flattenMaterial: function (pdfFolder, pdfAdditions) {
        return $q(function (resolve, reject) {
          $http({
            method: 'POST',
            url: web2print.env.pdfpreprocessBaseUrl + 'flatten',
            data: {
              'pdfFolder': pdfFolder,
              'pdfAdditions': pdfAdditions
            }
          }).then(function (response) {
            resolve(JSON.parse(response.data.message));
          }, function (response) {
            reject('Pdf flattening crashed');
          });
        });
      },
      getPdfContent: function (url) {
        return $q(function (resolve, reject) {
          $http.get(url, {
            responseType: 'arraybuffer'
          })
            .success(function (response) {
              resolve(response);
            })
            .error(function (error, status) {
              error.status = status;
              reject(error);
            });
        });
      }

    };
  }
})();
